import React from 'react';
import Slider from 'react-animated-slider';
import 'react-animated-slider/build/horizontal.css';
import { useSanityQuery } from '../../hooks/useSanityQuery';
import { urlFor } from '../../lib/imageUrlFor';

const QUERY = `*[_type == "homeSlide"] | order(order asc) {
  _id, title, description, buttonText, buttonLink, image
}`;

export default function SliderHome() {
  const { data, loading } = useSanityQuery(QUERY);

  if (loading || !data || data.length === 0) return <div />;

  return (
    <Slider className="slider-wrapper" autoplay={5000} touchDisabled={true}>
      {data.map((item) => (
        <div
          key={item._id}
          className="slider-content"
          style={{
            background: item.image?.asset
              ? `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url('${urlFor(item.image).width(1600).url()}') no-repeat center center`
              : 'linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6))',
          }}
        >
          <div className="inner">
            <h1>{item.title}</h1>
            <p>{item.description}</p>
            {item.buttonText && (
              <button onClick={() => window.open(item.buttonLink || '/', "_self")}>
                <div>
                  <span className="shine"></span>
                  <h7 className="text">{item.buttonText}</h7>
                </div>
              </button>
            )}
          </div>
        </div>
      ))}
    </Slider>
  );
}
